import {
  AllCommunityModule,
  ModuleRegistry,
  provideGlobalGridOptions,
  themeQuartz,
} from 'ag-grid-community'

export default defineNuxtPlugin((_) => {
  ModuleRegistry.registerModules([AllCommunityModule])

  provideGlobalGridOptions({ theme: themeQuartz })
})
